import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors } from '../../../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingBottom: 15,
    paddingTop: 20,
    // [theme.breakpoints.print]: {
    //   paddingTop: '40px',
    // },
  },
  dividerText:{
    paddingLeft:'5%',
    paddingRight:'5%'
  },
  alignRight: {
    textAlign: 'right',
  },
  contentTitle: {
    fontSize: 15,
     marginBottom: '24px !important',
  },
  contentSubTitle: {
    fontSize: 14,
    color: Colors.Blue,
    display: 'block',
    marginBottom: 10,
  },
  calculatedItems: {
    fontSize: 14,
    color: Colors.Gray,
    paddingLeft: '5%',
    marginBottom: '16px',
    lineHeight: '20px',
  },
  leftHalf: {
    paddingLeft: '10%',
  },
  rightHalf: {
    textAlign: 'center',
    marginTop: '20px',
    padding: '0 20px',
  },
  headerBanner: {
    padding: '0 10% !important',
    textAlign: 'left',
    marginTop: '40px !important',
  
    '& p': {
      fontSize: '14px !important',
      color: `${Colors.Blue} !important`,
    },
  },  
  divider: {
    background: Colors.Red,
    marginBottom: '15px',
    marginTop: '15px',
  },
  hsLogo: {
    height: 140,
    width: 'auto',
    margin: '0 auto',
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  leftPadding: {
    paddingLeft: '35px',
  },
}));

export default useStyles;
